import address from "./address.json";
import edit from "./edit.json";
import login from "./login.json";
import newCustomer from "./new.json";
import password from "./password.json";
import register from "./register.json";

export default {
  address,
  edit,
  login,
  new: newCustomer,
  password,
  register,
};
